export default {
  REDIRECT_URL: 'REDIRECT_URL',
  CUSTOMER_ID: 'CUSTOMER_ID',
  // DELIVERY_ADDRESS: 'DELIVERY_ADDRESS',
  BILLING_ADDRESS: 'BILLING_ADDRESS',
  PAYMENT_SERVICE: 'PAYMENT_SERVICE',
  DELIVERY_SERVICE: 'DELIVERY_SERVICE',
  // REFERENCE: 'REFERENCE',
  // COMMENT: 'COMMENT',
  CLIENT_DATA: 'CLIENT_DATA',
  TOS_AGREED: 'TOS_AGREED',
  CHECKOUT_PRIVACY_URL: 'CHECKOUT_PRIVACY_URL',
  CHECKOUT_TERMS_URL: 'CHECKOUT_TERMS_URL',
}
